(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3127],{

/***/ 94309:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/builders",
      function () {
        return __webpack_require__(69057);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_shared_fe_api_session__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60231);
/* harmony import */ var _opendoor_shared_fe_sagas__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23263);
/* harmony import */ var _opendoor_shared_fe_store_session__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20919);
/* harmony import */ var _opendoor_shared_fe_store_session_saga__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26407);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15467);
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21597);
/* harmony import */ var redux_immutable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72739);
/* harmony import */ var redux_saga__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87200);
/* harmony import */ var redux_saga_effects__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92242);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35480);













var sagas = function sagas() {
    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_8__/* .all */ .$6)([
                        (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_8__/* .fork */ .rM)(new _opendoor_shared_fe_store_session_saga__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(new _opendoor_shared_fe_api_session__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(_globals__WEBPACK_IMPORTED_MODULE_9__/* .XSRF_COOKIE_KEY */ .x0, _globals__WEBPACK_IMPORTED_MODULE_9__/* .RAILS_URL */ .oF)).saga)
                    ])
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
};
var sagaMiddleware = (0,redux_saga__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)({
    onError: _opendoor_shared_fe_sagas__WEBPACK_IMPORTED_MODULE_1__/* .sagaMiddlewareErrorHandler */ .e
});
var composeEnhancers = ( true && window).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux__WEBPACK_IMPORTED_MODULE_5__/* .compose */ .qC;
var reducers = {
    session: _opendoor_shared_fe_store_session__WEBPACK_IMPORTED_MODULE_2__/* ["default"].reducer */ .Z.reducer
};
var store = (0,redux__WEBPACK_IMPORTED_MODULE_5__/* .createStore */ .MT)((0,redux_immutable__WEBPACK_IMPORTED_MODULE_6__/* .combineReducers */ .U)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, reducers)), undefined, composeEnhancers((0,redux__WEBPACK_IMPORTED_MODULE_5__/* .applyMiddleware */ .md)(sagaMiddleware)));
sagaMiddleware.run(sagas);
var ReduxWrapper = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(react_redux__WEBPACK_IMPORTED_MODULE_4__/* .Provider */ .zt, {
        store: store,
        children: props.children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReduxWrapper);


/***/ }),

/***/ 69057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ builders; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/Layout.tsx + 10 modules
var Layout = __webpack_require__(63203);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Col.js
var Col = __webpack_require__(37122);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/TextInput.js
var TextInput = __webpack_require__(94746);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Row.js
var Row = __webpack_require__(6967);
// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/observability-slim.mjs
var observability_slim = __webpack_require__(74593);
// EXTERNAL MODULE: ./src/helpers/observability.ts
var observability = __webpack_require__(9574);
// EXTERNAL MODULE: ./src/components/api/index.ts + 3 modules
var api = __webpack_require__(61661);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
;// CONCATENATED MODULE: ./src/components/partners/BuilderSalesPage.tsx









var valuePropItems = [
    {
        header: "Streamline your process",
        description: "Create a custom profile to track and manage every touch point of your customer’s journey."
    },
    {
        header: "Help your client get started",
        description: "Help your client get started. Use the Home Eligibility Checker to confirm your client’s home is eligible."
    },
    {
        header: "Sell more homes, faster",
        description: "Get your clients a competitive estimated offer within minutes — all with a few simple clicks."
    },
    {
        header: "Access dedicated support",
        description: "Access your own partner manager, training, insights, and more to help you sell more homes."
    }, 
];
var BuilderSalesPage = function() {
    var trackEvent = (0,observability/* useObservability */.C3)().trackEvent;
    var ref = (0,react.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react.useState)(false), ctaInputLoading = ref1[0], setCtaInputLoading = ref1[1];
    var ref2 = (0,react.useState)(false), isEmailInvalid = ref2[0], setIsEmailInvalid = ref2[1];
    var ref3 = (0,react.useState)(false), emailFormatError = ref3[0], setEmailFormatError = ref3[1];
    (0,react.useEffect)(function() {
        observability_slim/* analytics.trackEvent */.co.trackEvent("partner-sign-up-flow", "view-landing-page");
    }, []);
    var isValidEmail = function(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var resp, normalizedEmail, redirectParams, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!email) return [
                            2
                        ];
                        if (!isValidEmail(email)) {
                            setEmailFormatError(true);
                            return [
                                2
                            ];
                        }
                        setCtaInputLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            api/* validatePartnerEmailAddress */.il(email)
                        ];
                    case 2:
                        resp = _state.sent();
                        if (!resp || !resp.validateEmail.isValid) {
                            setIsEmailInvalid(true);
                            setCtaInputLoading(false);
                            trackEvent("invalid-email", undefined, {
                                email: email
                            }, {
                                categoryOverride: "partner-sign-up-flow"
                            });
                            return [
                                2
                            ];
                        }
                        trackEvent("valid-email", undefined, undefined, {
                            categoryOverride: "partner-sign-up-flow"
                        });
                        normalizedEmail = resp.validateEmail.normalizedEmail;
                        redirectParams = new URLSearchParams();
                        redirectParams.set("email", normalizedEmail);
                        redirectParams.set("partnershipType", "HOME_BUILDER");
                        redirectParams.set("role", "partner_sales_referrer");
                        window.location.assign("".concat(globals/* PARTNERSHIP_BFF_URL */.Ff, "/sign-up?").concat(redirectParams.toString()));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setCtaInputLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
        p: "$16",
        gap: "$2",
        backgroundColor: "$backgroundAccentBrand",
        $largerThanMD: {
            height: "$150"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
            alignItems: "flex-start",
            mx: "auto",
            $largerThanXS: {
                px: "$0"
            },
            p: "$2",
            maxWidth: "$232",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                    gap: "$4",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "h1",
                            typography: "$headerSmall",
                            color: "$contentInversePrimary",
                            textAlign: "left",
                            maxWidth: "100%",
                            $largerThanSM: {
                                maxWidth: "$150"
                            },
                            children: "Sign up for your customized dashboard today"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                            width: "100%",
                            gap: "$1",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                    gap: "$2",
                                    alignItems: "flex-start",
                                    $largerThanSM: {
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                                            flex: 1,
                                            width: "100%",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextInput/* TextInput */.o, {
                                                size: "medium",
                                                ariaLabel: "Enter your work email",
                                                placeholder: "Enter your work email",
                                                value: email,
                                                onChangeText: function(value) {
                                                    setEmail(value);
                                                    setEmailFormatError(false);
                                                    setIsEmailInvalid(false);
                                                },
                                                inputMode: "email",
                                                autoComplete: "email"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                                            variant: "secondaryInverse",
                                            size: "medium",
                                            label: "Get started",
                                            "aria-label": "Get started",
                                            loading: ctaInputLoading,
                                            onPress: handleSubmit,
                                            analyticsName: "cosmos-builder-sales-page-cta-button"
                                        })
                                    ]
                                }),
                                emailFormatError && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "p",
                                    typography: "$labelSmall",
                                    color: "$contentInversePrimary",
                                    textAlign: "left",
                                    children: "Please enter a valid email address."
                                }),
                                isEmailInvalid && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "p",
                                    backgroundColor: "$backgroundStateInactiveAccentError",
                                    typography: "$labelSmall",
                                    pl: "$2",
                                    py: "$2",
                                    color: "$contentInversePrimary",
                                    textAlign: "left",
                                    borderRadius: "$4x",
                                    children: "Please use an email address associated with your builder to continue."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                    mt: "$22",
                    flexWrap: "wrap",
                    width: "100%",
                    gap: "$4",
                    $largerThanSM: {
                        flexWrap: "nowrap"
                    },
                    children: valuePropItems.map(function(valueProp, i) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                            width: "100%",
                            $largerThanSM: {
                                width: "25%"
                            },
                            gap: "$2",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "h4",
                                    typography: "$subheaderXsmall",
                                    color: "$contentInversePrimary",
                                    children: valueProp.header
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "p",
                                    color: "$contentInversePrimary",
                                    typography: "$bodySmall",
                                    width: "85%",
                                    children: valueProp.description
                                })
                            ]
                        }, i);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var partners_BuilderSalesPage = (BuilderSalesPage);

// EXTERNAL MODULE: ./src/components/shared/ReduxWrapper.tsx
var ReduxWrapper = __webpack_require__(3542);
;// CONCATENATED MODULE: ./src/pages/partners/builders.tsx





var Page = function(param) {
    var header = param.header, footer = param.footer;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReduxWrapper/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout/* default */.Z, {
            header: header !== null && header !== void 0 ? header : undefined,
            footer: footer !== null && footer !== void 0 ? footer : undefined,
            slug: "/partners/builders",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(partners_BuilderSalesPage, {})
        })
    });
};
var __N_SSG = true;
/* harmony default export */ var builders = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1176,3520,5527,6523,4468,9868,2345,7551,9086,4632,3178,8111,931,5675,4522,95,4991,2681,6885,3203,9774,2888,179], function() { return __webpack_exec__(94309); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);